import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EditHomeDialogComponent } from '../edit-home-dialog/edit-home-dialog.component';
import { HomePageContent } from '../models/content/home-page-content.model';
import { select, Store } from '@ngrx/store';
import { selectContent } from '../store/content.selectors';
import { Observable } from 'rxjs';
import { AppState } from '../store';
import { filter, map, tap } from 'rxjs/operators';
import { isLoggedIn, isLoggedOut, selectPublishedCourses, selectTenantInfo, selectUserPermissions, } from '../store/selectors';
import { minimalEditorConfig } from '../common/html-editor.config';
import { setSchoolNameAsPageTitle } from '../common/seo-utils';
import { Title } from '@angular/platform-browser';
import { homePageContentUpdated } from '../store/content.actions';
import { Course } from '../models/course.model';
import { createDefaultDialogConfig } from '../common/dialog-utils';
import { ResponsiveLayoutService } from '../services/responsive-layout.service';
import { EditTitleDescriptionDialogComponent } from '../shared/edit-title-description-dialog/edit-title-description-dialog.component';
import { TenantService } from '../services/tenant.service';
import { TenantInfo } from '../models/tenant.model';
import { SafeHtmlPipe } from '../shared/pipes/safe-html.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { PageFooterComponent } from '../shared/page-footer/page-footer.component';
import { NewsletterComponent } from '../newsletter/newsletter.component';
import { CourseCardComponent } from '../course-card/course-card.component';
import { CourseFilterComponent } from '../course-filter/course-filter.component';
import { LatestLessonsListComponent } from '../latest-lessons-list/latest-lessons-list.component';
import { EditableContainerComponent } from '../editable-container/editable-container.component';
import { AllowRoleDirective } from '../shared/auth/allow-role.directive';
import { AsyncPipe, NgClass, NgFor, NgIf, NgStyle } from '@angular/common';

@Component({
  selector: "home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  standalone: true,
  imports: [
    NgIf,
    NgStyle,
    AllowRoleDirective,
    NgFor,
    EditableContainerComponent,
    LatestLessonsListComponent,
    CourseFilterComponent,
    NgClass,
    CourseCardComponent,
    NewsletterComponent,
    PageFooterComponent,
    AsyncPipe,
    TranslateModule,
    SafeHtmlPipe,
  ],
})
export class HomeComponent implements OnInit {
  homePageContent$: Observable<HomePageContent>;

  tenant$: Observable<TenantInfo>;

  publishedCourses$: Observable<Course[]>;
  publishedCourses: Course[];

  isLoggedIn$: Observable<boolean>;
  isLoggedOut$: Observable<boolean>;

  editModeEnabled = false;

  // numberOfGridColumns = 2;

  // gridGutterSize = "1px";

  mobile = false;

  // verticalBenefits: boolean;
  // narrowBenefits: boolean;

  //toggle view list and grid
  isSwapCardView: boolean = true;

  private filteredCategoryIds: string[];
  filteredCourses: Course[] = null;

  swapCardView() {
    this.isSwapCardView = !this.isSwapCardView;
    localStorage.setItem('isSwapCardView', JSON.stringify(this.isSwapCardView));
  }

  constructor(
    private store: Store<AppState>,
    private dialog: MatDialog,
    private title: Title,
    private responsive: ResponsiveLayoutService,
    private tenant: TenantService
  ) { }

  ngOnInit() {

    try {
      if (localStorage.getItem('isSwapCardView')) {
        this.isSwapCardView = JSON.parse(localStorage.getItem('isSwapCardView'));
      }
    }
    catch (ex) {
      this.isSwapCardView = true;
    }

    setSchoolNameAsPageTitle(this.store, this.title);

    this.homePageContent$ = this.store.pipe(select(selectContent("homePage")));

    this.tenant$ = this.store.pipe(select(selectTenantInfo));

    this.isLoggedIn$ = this.store.pipe(select(isLoggedIn));

    this.isLoggedOut$ = this.store.pipe(select(isLoggedOut));

    // getting published courses
    this.store.pipe(
      select(selectPublishedCourses),
      map((courses) => courses.filter((course) => !course.hiddenCourseOn))
    ).subscribe(courses => this.publishedCourses = courses);

    this.store
      .pipe(select(selectUserPermissions))
      .subscribe(
        (permissions) =>
          (this.editModeEnabled = permissions && permissions.isAdmin)
      );

    // this.responsive
    //   .matchesAny(Breakpoints.Handset, Breakpoints.TabletPortrait)
    //   .subscribe((matches) => {
    //     this.numberOfGridColumns = matches ? 1 : 2;
    //     this.gridGutterSize = matches ? "40px" : "1px";
    //   });

    // this.responsive
    //   .matchesAny(Breakpoints.Handset, Breakpoints.Tablet)
    //   .subscribe((matches) => (this.mobile = matches));

    // this.responsive
    //   .matchesAny(Breakpoints.HandsetPortrait)
    //   .subscribe((matches) => (this.verticalBenefits = matches));

    // this.responsive
    //   .matchesAny(Breakpoints.HandsetLandscape, Breakpoints.TabletPortrait)
    //   .subscribe((matches) => (this.narrowBenefits = matches));
  }

  editPageHeader(content: HomePageContent) {
    const dialogConfig = createDefaultDialogConfig();

    dialogConfig.width = "550px";
    dialogConfig.minHeight = "600px";

    this.dialog.open(EditHomeDialogComponent, dialogConfig);
  }

  onBenefitEdited(content: HomePageContent, benefitIndex: number) {
    const benefit = content.benefits[benefitIndex];

    const dialogConfig = createDefaultDialogConfig();

    dialogConfig.width = "550px";

    dialogConfig.data = {
      dialogTitle: "Edit Headline",
      title: benefit?.title.startsWith("Hover with the mouse")
        ? ""
        : benefit.title,
      description: benefit?.description.startsWith("Enter the text benefit")
        ? ""
        : benefit?.description,
      editorConfig: minimalEditorConfig,
    };

    this.dialog
      .open(EditTitleDescriptionDialogComponent, dialogConfig)
      .afterClosed()
      .pipe(
        filter((val) => !!val),
        tap((val) => {
          const newContent = {
            ...content,
            benefits: content.benefits.slice(0),
          };

          newContent.benefits[benefitIndex] = {
            title: val.title,
            description: val.description,
          };

          this.store.dispatch(homePageContentUpdated({ content: newContent }));
        })
      )
      .subscribe();
  }

  homeBannerStyles(content: HomePageContent) {
    if (content.bannerImageUrl) {
      return {
        "background-image": "url('" + content.bannerImageUrl + "')",
      };
    } else {
      return {
        "background-color": "rgb(186, 190, 192)",
      };
    }
  }

  calculateTitleStyles(content: HomePageContent) {
    return {
      color: content.pageTitleColor,
      "font-size": `${content.titleFontSize}px`,
    };
  }

  onSignupClicked() {
    const button: HTMLBaseElement = document.querySelector("#loginButton");
    button.click();
  }

  // for filtering courses per category
  onFilterPerCategoryChanged(categoryIds: string[]) {

    if (!categoryIds?.length) {
      this.filteredCourses = this.publishedCourses;
      return;
    }

    this.filteredCategoryIds = categoryIds;

    this.filterCoursesPerCategory();

  }

  filterCoursesPerCategory() {

    const filtered = this.publishedCourses?.filter(course => {
      return course.categories?.some(categoryId => this.filteredCategoryIds?.includes(categoryId));
    });

    this.filteredCourses = filtered ? filtered : [];

    if (!this.filteredCourses?.length) {
      this.filteredCourses = null
    }
  }

}
